"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isActive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CategoryButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "category-item__CategoryButton",
  componentId: "sc-870p95-0"
})(["position:relative;", ";"], (0, _styles.transitionEase)("0.7s", ["transform"]));
var ItemLabel = (0, _styledComponents["default"])(function (_ref) {
  var isActive = _ref.isActive,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, props);
}).withConfig({
  displayName: "category-item__ItemLabel",
  componentId: "sc-870p95-1"
})(["", ";color:", ";"], (0, _styles.transitionEase)("0.7s", ["color"]), function (props) {
  return props.isActive ? (0, _styles.themeDarken)(0.2, "blue", props) : (0, _styles.colors)("blue", props);
});
var ItemBack = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "category-item__ItemBack",
  componentId: "sc-870p95-2"
})(["cursor:pointer;position:relative;background-color:", ";box-shadow:0 4px 16px 0 ", ",0 2px 4px 0 ", ";"], function (props) {
  return (0, _styles.colors)("background", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.84, "background-dark")(props);
});
var ItemContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "category-item__ItemContainer",
  componentId: "sc-870p95-3"
})(["min-width:240px;box-sizing:border-box;vertical-align:bottom;&:hover{", "{transform:translateY(-4px);}", "{box-shadow:0 0 24px ", ";}", "{color:", ";}}"], CategoryButton, ItemBack, function (props) {
  return (0, _styles.themeTransparentize)(0.5, "border")(props);
}, ItemLabel, function (props) {
  return (0, _styles.themeDarken)(0.2, "blue", props);
});
var DropShadow = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "category-item__DropShadow",
  componentId: "sc-870p95-4"
})(["position:absolute;left:8px;right:8px;height:100%;top:0;", ";opacity:0;box-shadow:0 8px 16px ", ";", ":hover &{opacity:1;box-shadow:0 8px 16px ", ";}"], (0, _styles.transitionEase)("0.7s", ["box-shadow", "opacity"]), function (props) {
  return (0, _styles.themeTransparentize)(1, "border")(props);
}, ItemContainer, function (props) {
  return (0, _styles.themeTransparentize)(0.2, "border")(props);
});
var propTypes = {
  /** Title text usually text, but can be a React component  */
  categoryClick: _propTypes.func,

  /**  text of category item * */
  children: _propTypes.node,

  /** Title text usually text, but can be a React component  */
  isActive: _propTypes.bool,

  /** Value of category to send to click function  */
  itemGutter: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** click handler for item  */
  itemWidth: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),

  /** setting for number of item width * */
  value: _propTypes.string
};
var labelFont = {
  fontSize: 5,
  fontWeight: 700,
  letterSpacing: 0.3,
  lineHeight: 2,
  textAlign: "left"
};

var CategoryItem = function CategoryItem(_ref2) {
  var categoryClick = _ref2.categoryClick,
      children = _ref2.children,
      isActive = _ref2.isActive,
      itemWidth = _ref2.itemWidth,
      itemGutter = _ref2.itemGutter;
  return /*#__PURE__*/_react["default"].createElement(ItemContainer, {
    display: "inline-block",
    height: 108,
    mb: 3,
    px: itemGutter,
    width: itemWidth
  }, /*#__PURE__*/_react["default"].createElement(CategoryButton, {
    height: 1,
    onClick: categoryClick,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(DropShadow, null), /*#__PURE__*/_react["default"].createElement(ItemBack, {
    alignItems: "center",
    borderRadius: 8,
    height: 1,
    justifyContent: "flex-start",
    px: 3,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(ItemLabel, _extends({
    isActive: isActive
  }, labelFont), children))));
};

CategoryItem.propTypes = propTypes;
var _default = CategoryItem;
exports["default"] = _default;